import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesStaff } from "./../../constants/enums";
import { DeleteStaffManagerResponse } from "./deleteStaffManager.types";

export const requestDeleteStaffManager = async (
  staffManagerId: string
): Promise<DeleteStaffManagerResponse> => {
  return await instance.delete(
    buildUrl(ApiRoutesStaff.StaffManager, staffManagerId)
  );
};
